// Generated by scripts/generate-strategy-partner-assets.mjs

export interface CampaignImageCandidate {
  path: string;
  width: number;
}

export interface CampaignImageAsset {
  avif: readonly CampaignImageCandidate[];
  fallback: CampaignImageCandidate;
  height: number;
  jpeg: readonly CampaignImageCandidate[];
  sizes: string;
  width: number;
}

export const STRATEGY_PARTNER_IMAGES = {
  "bitwiseCover": {
    "avif": [
      {
        "path": "/assets/strategy-partner/optimized/bitwise-cover-deeea5ee7aaa-960.avif",
        "width": 960
      },
      {
        "path": "/assets/strategy-partner/optimized/bitwise-cover-deeea5ee7aaa-1600.avif",
        "width": 1600
      },
      {
        "path": "/assets/strategy-partner/optimized/bitwise-cover-deeea5ee7aaa-2560.avif",
        "width": 2560
      },
      {
        "path": "/assets/strategy-partner/optimized/bitwise-cover-deeea5ee7aaa-3840.avif",
        "width": 3840
      }
    ],
    "fallback": {
      "path": "/assets/strategy-partner/optimized/bitwise-cover-deeea5ee7aaa-3840.jpg",
      "width": 3840
    },
    "height": 1463,
    "jpeg": [
      {
        "path": "/assets/strategy-partner/optimized/bitwise-cover-deeea5ee7aaa-960.jpg",
        "width": 960
      },
      {
        "path": "/assets/strategy-partner/optimized/bitwise-cover-deeea5ee7aaa-1600.jpg",
        "width": 1600
      },
      {
        "path": "/assets/strategy-partner/optimized/bitwise-cover-deeea5ee7aaa-2560.jpg",
        "width": 2560
      },
      {
        "path": "/assets/strategy-partner/optimized/bitwise-cover-deeea5ee7aaa-3840.jpg",
        "width": 3840
      }
    ],
    "sizes": "(min-width: 1504px) 1440px, 100vw",
    "width": 4095
  },
  "bitwiseRobotics": {
    "avif": [
      {
        "path": "/assets/strategy-partner/optimized/bitwise-robotics-3c7666fc5c9e-768.avif",
        "width": 768
      },
      {
        "path": "/assets/strategy-partner/optimized/bitwise-robotics-3c7666fc5c9e-1440.avif",
        "width": 1440
      }
    ],
    "fallback": {
      "path": "/assets/strategy-partner/optimized/bitwise-robotics-3c7666fc5c9e-1440.jpg",
      "width": 1440
    },
    "height": 941,
    "jpeg": [
      {
        "path": "/assets/strategy-partner/optimized/bitwise-robotics-3c7666fc5c9e-768.jpg",
        "width": 768
      },
      {
        "path": "/assets/strategy-partner/optimized/bitwise-robotics-3c7666fc5c9e-1440.jpg",
        "width": 1440
      }
    ],
    "sizes": "(min-width: 1280px) 33vw, (min-width: 768px) 50vw, calc(100vw - 2rem)",
    "width": 1672
  },
  "bitwiseUsAiLeaders": {
    "avif": [
      {
        "path": "/assets/strategy-partner/optimized/bitwise-us-ai-leaders-c950e74b3b85-768.avif",
        "width": 768
      },
      {
        "path": "/assets/strategy-partner/optimized/bitwise-us-ai-leaders-c950e74b3b85-1440.avif",
        "width": 1440
      }
    ],
    "fallback": {
      "path": "/assets/strategy-partner/optimized/bitwise-us-ai-leaders-c950e74b3b85-1440.jpg",
      "width": 1440
    },
    "height": 941,
    "jpeg": [
      {
        "path": "/assets/strategy-partner/optimized/bitwise-us-ai-leaders-c950e74b3b85-768.jpg",
        "width": 768
      },
      {
        "path": "/assets/strategy-partner/optimized/bitwise-us-ai-leaders-c950e74b3b85-1440.jpg",
        "width": 1440
      }
    ],
    "sizes": "(min-width: 1280px) 33vw, (min-width: 768px) 50vw, calc(100vw - 2rem)",
    "width": 1672
  }
} as const satisfies Record<"bitwiseCover" | "bitwiseRobotics" | "bitwiseUsAiLeaders", CampaignImageAsset>;
